import { useState } from 'react'
import styled from 'styled-components'
import parse from 'html-react-parser'
import { Copy } from '@stokr/components-library'
import { stoColor, stoSpace } from 'constants/stoTheme'
import { Section } from 'components/sto/Section'
import { Collapsible } from 'components/ui/collapsible'
import { useImportantConsiderations } from 'hooks/sto/useImportantConsiderations'
import { useStoTrack } from 'hooks/sto/useStoTracking'

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${stoSpace[2]};
`

/**
 * Black, not the collapsible's secondary grey: these are disclosures, read in full. One even gap
 * between paragraphs, whatever the copy adds (the Tax ID text puts a `<br/>` between them).
 */
const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${stoSpace[3]};
  color: ${stoColor.textPrimary};

  /* Back-office pastes colours inline; the disclosures are always black. */
  & * {
    color: ${stoColor.textPrimary} !important;
  }

  p {
    margin: 0;
  }

  & > br {
    display: none;
  }
`

export const ImportantConsiderations = () => {
  const state = useImportantConsiderations()
  const [openIndex, setOpenIndex] = useState<number | null>(null)
  const trackSto = useStoTrack()

  return (
    <Section
      anchor="risks"
      title={<Copy id="stoPage.importantConsiderations.title" />}
      state={state}
      collapsible="always">
      {(items) => (
        <List>
          {items.map((item, index) => (
            <Collapsible
              key={`${index}-${item.title}`}
              title={item.title}
              open={openIndex === index}
              dataCy={`sto-consideration-toggle-${index}`}
              onToggle={(open) => {
                trackSto('sto_consideration_toggled', { index, topic: item.title, open })
                setOpenIndex(open ? index : null)
              }}>
              <Text>{parse(item.text)}</Text>
            </Collapsible>
          ))}
        </List>
      )}
    </Section>
  )
}
